import React from 'react'
import ReactDOM from 'react-dom'
import App from "../src/public_share_module/components/app_module"


const loadPublicShareLandingApp = () => {
  ReactDOM.render(<App />,document.querySelector("#ph-pslndgpage-main"))
}

photoOrg.loadPublicShareLandingApp = loadPublicShareLandingApp;   

